import { Network } from "../../.."

export class twoFactorAuth {
	static async sendTwoFactorAuth(userId, authType) {
		const response = await Network.AxiosWrapperV2.get({
			url: `/twofactorauth/send?userId=${userId}&authType=${authType}`
		})

		return response?.data
	}
}

export default twoFactorAuth
